var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSupport = function SvgSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 42 42"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8,
    d: "M19.25 24.501h3.5a3.5 3.5 0 0 0 0-7H17.5c-1.05 0-1.925.35-2.45 1.05l-9.8 9.45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8,
    d: "m12.251 34.997 2.8-2.45c.525-.7 1.4-1.05 2.45-1.05h7c1.925 0 3.675-.7 4.9-2.1l8.05-7.7a3.504 3.504 0 0 0-4.812-5.092l-7.35 6.825M3.499 26.25l10.5 10.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8,
    d: "M33.951 14.873c1.225-1.225 2.625-2.8 2.625-4.725a4.778 4.778 0 0 0-8.75-3.15 4.865 4.865 0 0 0-8.75 3.15c0 2.1 1.4 3.5 2.625 4.9l6.125 5.95z"
  })));
};
export default SvgSupport;